var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('vue-pdf-embed',{attrs:{"source":_vm.loadPdf()},on:{"rendered":function($event){_vm.isLoading = false}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }